// get state from localstorage and set in store

export default function getSavedState(key) {
  if (window.localStorage['auth'] !== 'undefined')
    return JSON.parse(window.localStorage.getItem(key))
  else return null
}
